import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Landing() {
  const navigate = useNavigate();
  const [learnOpen, setLearnOpen] = useState(false);

  return (
    <div className="brand-page-shell">
      <style>{brandPageStyles}</style>

      <div className="brand-page-content">
        <div className="brand-image-wrap">
          <img
            src="/brand-page-2026.png"
            alt="Doctor Is In App"
            className="brand-main-image"
          />

          <div className="brand-actions">
            <button onClick={() => navigate("/login")}>LOGIN</button>
            <button onClick={() => navigate("/school-registration")}>REGISTER</button>
            <button className="learn-btn" onClick={() => setLearnOpen(true)}>
              LEARN MORE
            </button>
          </div>
        </div>
      </div>

      {learnOpen && (
        <div className="learn-overlay" role="dialog" aria-modal="true">
          <div className="learn-modal">
            <button className="learn-close" type="button" onClick={() => setLearnOpen(false)}>
              ×
            </button>

            <h1>Welcome to Doctor Is In App™</h1>
            <div className="learn-lead">AI Advisor With A Human Touch</div>

            <p>
              Doctor Is In App™ combines AI wellness guidance, live advisors, and school wellness
              intelligence to support students, parents, teachers, advisors, and schools.
            </p>

            <div className="learn-grid">
              <section>
                <h2>🌟 Meet Casey</h2>
                <p>
                  Casey is your AI Wellness Advisor, available to listen, provide guidance, and help
                  users decide the next safe step.
                </p>
              </section>

              <section>
                <h2>What Casey Helps With</h2>
                <ul>
                  <li>Stress, anxiety, sadness, and feeling overwhelmed</li>
                  <li>Bullying, school pressure, trauma, and grief</li>
                  <li>Digital influence, cyberbullying, sextortion, and viral challenges</li>
                  <li>Healthy habits, sleep, nutrition, body image, and eating concerns</li>
                  <li>Vaping, alcohol, drugs, medication misuse, and peer pressure</li>
                </ul>
              </section>

              <section>
                <h2>🌦️ What is AURA™?</h2>
                <p>
                  AURA™ is your school’s Emotional Weather Map. It helps schools recognize wellness
                  trends so they can respond with education, resources, and support.
                </p>
              </section>

              <section>
                <h2>Available Portals</h2>
                <ul>
                  <li>Students</li>
                  <li>Parents & Teachers</li>
                  <li>Advisors</li>
                  <li>School Administrators</li>
                </ul>
              </section>
            </div>

            <div className="learn-purpose">
              <strong>What Casey is designed for:</strong> Casey specializes in student health,
              wellness, emotional wellbeing, school life, and healthy decision-making. Casey is not
              a substitute for emergency services, licensed medical care, diagnosis, treatment, or
              legal advice.
            </div>

            <div className="learn-mission">
              Our mission is to make trusted wellness support available anytime, anywhere, for every
              student, every family, every educator, and every school.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const brandPageStyles = `
  .brand-page-shell {
    min-height: 100vh;
    width: 100%;
    background: linear-gradient(135deg, #54c9ff 0%, #518ad0 45%, #496cb8 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .brand-page-content {
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 22px;
  }

  .brand-image-wrap {
    position: relative;
    width: min(96vw, 1560px);
  }

  .brand-main-image {
    width: 100%;
    max-height: 94vh;
    object-fit: contain;
    display: block;
    border-radius: 22px;
    box-shadow: 0 20px 50px rgba(0,0,0,.24);
  }

  .brand-actions {
    position: absolute;
    top: 6%;
    right: 5%;
    display: flex;
    gap: 14px;
    z-index: 5;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .brand-actions button {
    border-radius: 14px;
    padding: 14px 24px;
    font-weight: 900;
    cursor: pointer;
    border: 1px solid rgba(0,0,0,.16);
    background: white;
    box-shadow: 0 10px 24px rgba(0,0,0,.14);
  }

  .brand-actions button:first-child {
    border: none;
    color: white;
    background: linear-gradient(135deg, #ff8a3d, #ff4d6d);
  }

  .brand-actions .learn-btn {
    color: #15335f;
    background: rgba(255,255,255,.94);
  }

  .learn-overlay {
    position: fixed;
    inset: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(12, 26, 54, .46);
    backdrop-filter: blur(8px);
  }

  .learn-modal {
    position: relative;
    width: min(940px, 94vw);
    max-height: 88vh;
    overflow-y: auto;
    border-radius: 26px;
    padding: 30px;
    background: rgba(255,255,255,.94);
    box-shadow: 0 30px 90px rgba(0,0,0,.36);
    color: #172033;
  }

  .learn-close {
    position: absolute;
    top: 16px;
    right: 18px;
    width: 38px;
    height: 38px;
    border-radius: 999px;
    border: 1px solid rgba(0,0,0,.12);
    background: white;
    cursor: pointer;
    font-size: 26px;
    line-height: 1;
    font-weight: 800;
  }

  .learn-modal h1 {
    margin: 0;
    text-align: center;
    font-size: clamp(26px, 4vw, 40px);
    font-weight: 950;
    color: #15335f;
  }

  .learn-lead {
    text-align: center;
    margin: 6px 0 18px;
    font-size: 16px;
    font-weight: 900;
    color: #138fb1;
  }

  .learn-modal p {
    font-size: 15px;
    line-height: 1.55;
  }

  .learn-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-top: 18px;
  }

  .learn-grid section,
  .learn-purpose,
  .learn-mission {
    border: 1px solid rgba(21, 51, 95, .12);
    border-radius: 18px;
    padding: 16px;
    background: rgba(255,255,255,.76);
  }

  .learn-grid h2 {
    margin: 0 0 8px;
    font-size: 18px;
    color: #15335f;
  }

  .learn-grid ul {
    margin: 0;
    padding-left: 20px;
    line-height: 1.55;
    font-size: 14px;
  }

  .learn-purpose {
    margin-top: 16px;
    line-height: 1.55;
    background: rgba(232, 247, 252, .82);
  }

  .learn-mission {
    margin-top: 14px;
    text-align: center;
    font-weight: 900;
    color: #15335f;
  }

  @media (max-width: 700px) {
    .brand-actions {
      top: 3%;
      right: 4%;
      gap: 8px;
    }

    .brand-actions button {
      padding: 10px 12px;
      font-size: 12px;
    }

    .brand-page-content {
      padding: 12px;
    }

    .learn-grid {
      grid-template-columns: 1fr;
    }

    .learn-modal {
      padding: 24px 18px;
    }
  }
`;
